const functions = {
    animate({timing, draw, duration}) {

        let start = performance.now();
    
        requestAnimationFrame(function animate(time) {
            // timeFraction goes from 0 to 1
            let timeFraction = (time - start) / duration;
            if (timeFraction > 1) timeFraction = 1;
        
            // calculate the current animation state
            let progress = timing(timeFraction)
        
            draw(progress); // draw it
        
            if (timeFraction < 1) {
                requestAnimationFrame(animate);
            }
    
        });
    },

    lerp(start, end, ratio){
        return (1-ratio)*start+ratio*end;
    },

    Ease: {
        // quad(timeFraction) {
        //     return Math.pow(timeFraction, 2)
        // },
        
        // circ(timeFraction) {
        //     return 1 - Math.sin(Math.acos(timeFraction));
        // },

        // bounce(timeFraction) {
        //     for (let a = 0, b = 1, result; 1; a += b, b /= 2) {
        //         if (timeFraction >= (7 - 4 * a) / 11) {
        //         return -Math.pow((11 - 6 * a - 11 * timeFraction) / 4, 2) + Math.pow(b, 2)
        //         }
        //     }
        // },

        // elastic(x, timeFraction) {
        //     return Math.pow(2, 10 * (timeFraction - 1)) * Math.cos(20 * Math.PI * x / 3 * timeFraction)
        // },

        // quadOut(timeFraction){  
        //     return Math.pow(timeFraction, 2)
        // },
        
        // circOut(timeFraction){ 
        //     return 1 - Math.sin(Math.acos(timeFraction));
        // },

        // bounceOut(){ 
            
        // },

        // no easing, no acceleration
        linear(t) { return t },
        // accelerating from zero velocity
        easeInQuad(t) { return t*t },
        // decelerating to zero velocity
        easeOutQuad(t) { return t*(2-t) },
        // acceleration until halfway, then deceleration
        easeInOutQuad(t) { return t<.5 ? 2*t*t : -1+(4-2*t)*t },
        // accelerating from zero velocity 
        easeInCubic(t) { return t*t*t },
        // decelerating to zero velocity 
        easeOutCubic(t) { return (--t)*t*t+1 },
        // acceleration until halfway, then deceleration 
        easeInOutCubic(t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 },
        // accelerating from zero velocity 
        easeInQuart(t) { return t*t*t*t },
        // decelerating to zero velocity 
        easeOutQuart(t) { return 1-(--t)*t*t*t },
        // acceleration until halfway, then deceleration
        easeInOutQuart(t) { return t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t },
        // accelerating from zero velocity
        easeInQuint(t) { return t*t*t*t*t },
        // decelerating to zero velocity
        easeOutQuint(t) { return 1+(--t)*t*t*t*t },
        // acceleration until halfway, then deceleration 
        easeInOutQuint(t) { return t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t }

    },

}



export default functions;


// WEBPACK FOOTER //
// ./src/Animator.js